<template>
    <div id="Measures">
        <measureAddDialog v-bind:dialogAdd="dialogAdd" :paramOptions="paramOptions" @update="getData"
                          :measureInfo="measureInfo"></measureAddDialog>
        <measureAddBatch v-bind:batchDialog="batchDialog" :paramOptions="paramOptions" @update="getData"
                         :measureInfo="measureInfo"></measureAddBatch>
        <measureInfo :dialogCheck="dialogCheck" :form="form" :type="type"></measureInfo>
        <EditCedian :dialogEdit="dialogEdit" :cedianForm="cedianForm" :type_edit="type_edit"
                    @updateEdit="getData"></EditCedian>
        <ChildCedian :dialogChild="dialogChild" :childCedian="childCedian" :measureNo="measureNo"
                     @update="getData()"></ChildCedian>
        <div class="data_head">
            <span class="text_panel">参数选择</span>
            <el-cascader
                v-model="measureNo"
                :options="paramOptions"
                :props="{value:'code',label:'name',children:'childList',emitPath:false}"
                :show-all-levels="false"
                @change="handleChange">
            </el-cascader>
            <el-button type="primary" @click="search()" class="searchButton">查&nbsp;询</el-button>
            <el-button type="primary" @click="handleAdd()" class="searchButton">添&nbsp;加</el-button>
            <!--        <el-button type="primary" @click="batchAdd()" class="searchButton">批量添加</el-button>-->
        </div>
        <div class="table tableContent">
            <el-table :data="data" style="width: 100%;" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column align="center" prop="childProjectName" label="所属结构"></el-table-column>
                <el-table-column align="center" prop="measureNo" label="测点编号"></el-table-column>
                <el-table-column align="center" prop="alias" label="别名"></el-table-column>
                <el-table-column align="center" prop="measureInfo" label="传感器"></el-table-column>
                <el-table-column align="center" prop="deviceSn" label="模块序列号"></el-table-column>
                <el-table-column align="center" prop="cretateTime" label="添加时间" :formatter="dateFormatter"
                                 width="160"></el-table-column>
                
                <el-table-column align="center" label="操作" fixed="right" width="300">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button size="mini" @click="handleCheck(scope.row)" type="primary">查看</el-button>
                            <el-button size="mini" @click="handleDelete(scope.row)" type="danger">删除</el-button>
                            <el-button size="mini" @click="setInitData(scope.row)" type="warning">初始数据</el-button>
                            <el-button size="mini" @click="setInitValue(scope.row)" type="success">初始值</el-button>
                            <!--              <el-button size="mini" @click="setAlarm(scope.row)" type="primary">报警器</el-button>-->
                        </el-button-group>
                        <!--  <template>
                             <el-button size="mini" @click="getChild(scope.row)"
                                 v-if="scope.row.measureNo.startsWith('0103') || scope.row.measureNo.startsWith('0106')">
                                 子测点
                             </el-button>
                         </template> -->
                    </template>
                </el-table-column>
                <el-table-column label='报警开/关' fixed="right">
                    <template slot-scope="scope">
                        <el-switch
                            @change="alarmSwitch(scope.row,$event)"
                            v-model="scope.row.noticeSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="开"
                            inactive-text="关"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
            
            </el-table>
            <div class="pagination">
                <el-pagination
                    @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize"
                    :hide-on-single-page="true"
                    layout="total,prev, pager, next, jumper"
                    :total="total" class="pagination" background>
                </el-pagination>
            </div>
        </div>
        
        
        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body="false">
            <span>删除不可恢复，是否确定删除？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="del">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 初始数据Dialog -->
        <el-dialog title="数据初始化" :visible.sync="initDataDialog" width="18%" :modal-append-to-body="false">
            <el-input v-model="initData"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="initDataDialog = false">取 消</el-button>
            <el-button type="primary" @click="sureInitData()">确 定</el-button>
        </span>
        </el-dialog>
        <!-- 初始值Dialog -->
        <el-dialog title="设置初始值" :visible.sync="initValueDialog" width="18%" :modal-append-to-body="false">
            频率初始值
            <el-input v-model="frequencyValue"></el-input>
            温度初始值
            <el-input v-model="tvalue"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="initValueDialog = false">取 消</el-button>
            <el-button type="primary" @click="sureInitValue()">确 定</el-button>
         </span>
        </el-dialog>
        <!--报警器选择Dialog-->
    
    </div>
</template>

<script>
import measureAddDialog from './measure-add-dialog'
import measureAddBatch from './measure-add-batch'
import measureInfo from './measure-info'
import EditCedian from './EditCedian'
import ChildCedian from './ChildCedian'

export default {
    name: 'measures',
    components: {
        measureAddDialog,//添加单个测点
        measureAddBatch,//批量添加
        measureInfo,
        EditCedian,
        ChildCedian
    },
    data() {
        return {
            paramOptions: [],//页面级联选择框的参数
            measureInfo: null,//传递测点数据
            select_word: '',
            data: [],
            cedianInfo: [],
            paramsOptions: [],
            total: null,
            page: 1, // 初始页
            pageSize: 10, // 每页显示的数据条数
            value1: '',
            value2: '',
            code: '',
            params: '',
            dialogAdd: {show: false},
            batchDialog: {show: false},
            dialogCheck: {show: false},
            dialogEdit: {show: false},
            dialogChild: {show: false},
            delDialogVisible: false,
            type: '',
            type_edit: '',
            form: {},
            cedianForm: {},
            childCedian: [],
            measureNo: '',
            initDataDialog: false,
            initData: '', // 初始数据
            initValueDialog: false,
            frequencyValue: '', // 频率值
            tvalue: '', // 温度值
        };
    },
    mounted: function () {
        this.getData();
        this.getParamSelectData();
    },
    methods: {
        getData(param) {
            // console.log(param,page,'page部分')
            // if (page == null) {
            //   page = 1;
            // }
            if (this.measureNo) {
                param = this.measureNo
            }
            this.$axios.get('/api/monitor/project/measure/getChildProjectAllMeasures?pageNum=' + this.page + (param == null ? '' : '&query=' + param)).then(res => {
                if (res.data.status == 200) {
                    this.total = res.data.datas.values.total;
                    this.data = res.data.datas.values.list;
                    this.pageSize = res.data.datas.values.pageSize
                }
                return
            });
        },
        getParamSelectData() {
            let childProjectId = localStorage.getItem("mainId");
            this.$axios.get('/api/monitor/project/measure/parameterSelection?id=' + childProjectId).then(res => {
                if (res.data.status == 200) {
                    this.paramOptions = res.data.datas.values;
                }
                return
            });
        },
        dateFormatter(row, column, cellValue) {
            if (cellValue != null) {
                let date = new Date(cellValue);
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = date.getHours() + ':';
                let m = date.getMinutes() + ':';
                let s = date.getSeconds();
                return Y + M + D + h + m + s;
            } else {
                return ''
            }
        },
        search() {
            this.page = 1
            this.getData(this.measureNo);
        },
        
        handleChange(event) {
            this.params = event.code; // 拿到查询接口中请求参数
        },
        handleCurrentChange(val) {
            if (this.measureNo) {
                this.page = val
                this.getData(this.measureNo)
            } else {
                this.page = val
                this.getData(null)
            }
            
        },
        //  单个测点添加
        handleAdd() {
            this.measureInfo = null;
            this.dialogAdd.show = true;
        },
        //  批量添加
        batchAdd() {
            this.measureInfo = null;
            this.batchDialog.show = true;
        },
        //  查看
        handleCheck(row) {
            this.dialogAdd.show = true;
            this.measureInfo = row;
        },
        //  删除
        handleDelete(row) {
            this.delId = row.id;
            this.delDialogVisible = true;
        },
        del() {
            this.$axios.delete('/api/monitor/project/deleteMeasureById', {params: {measureId: this.delId}}).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: res.data.datas.values
                    })
                    this.delDialogVisible = false;
                    this.getData();
                }
                return
            })
        },
        //  初始化数据
        setInitData(row) {
            this.measureId = row.id;
            this.initDataDialog = true;
            this.initData = row.alarmDataJsonVo.initValue;
        },
        //  初始化数据按钮
        sureInitData() {
            this.$axios.put(`/api/monitor/project/updateMeasureInitValue?measureId=${this.measureId}`, {initValue: this.initData}).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '数据初始化成功'
                    })
                    this.initDataDialog = false;
                    this.getData();
                }
                return
            })
        },
        //  初始值弹框
        setInitValue(row) {
            this.measureId = row.id;
            this.initValueDialog = true;
            this.frequencyValue = row.alarmDataJsonVo.frequencyValue;
            this.tvalue = row.alarmDataJsonVo.tvalue;
        },
        //  初始值确定按钮
        sureInitValue() {
            this.$axios.put(`/api/monitor/project/updateMeasureInitValue?measureId=${this.measureId}`, {
                frequencyValue: this.frequencyValue,
                tvalue: this.tvalue
            }).then(res => {
                if (res.data.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '成功设置初始值'
                    })
                    this.initValueDialog = false;
                    this.getData();
                }
                return
            })
        },
        getChild(row) {
            this.dialogChild.show = true;
            this.measureNo = row.measureNo;
            const req = {
                measureNo: this.measureNo
            }
            this.$axios.post('/api/project/getChild', req).then(res => {
                this.childCedian = res.data.data.data;
            })
        },
        /*改变警报器开关*/
        alarmSwitch(info, val) {
            this.$axios.put('/api/monitor/project/updateAlarmStatus?id=' + info.id + '&alarmStatus=' + val).then(res => {
                if (res.data.status == 200) {
                    if (val) {
                        this.$message({message: '报警器开启成功', type: 'success'})
                    } else {
                        this.$message({message: '报警器关闭成功', type: 'warning'})
                    }
                    this.getData()
                } else if (res.data.datas.values == '当前构件没有绑定报警器设备') {
                    this.$confirm(res.data.datas.values)
                    this.getData()
                } else {
                    this.$message({message: res.data.message, type: 'error'})
                }
            })
        }
        
    }
}
</script>

<style>

#Measures .el-cascader .el-input .el-input__inner {
    color: #FFF;
    background-color: #3457DE;
}

#Measures .el-date-editor .el-input__inner {
    background-color: #3457DE;
    color: #FFF;
}

#Measures .el-table {
    color: #A7CCF6;
}

#Measures .el-table__row {
    background-color: #0B3A68 !important;
}

#Measures .el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #021535;
}

#Measures .el-table td {
    border: unset;
}

#Measures .el-table th.is-leaf {
    border-bottom: none;
}

</style>

<style scoped>
@import url('../../assets/css/style.css');

.pagination {
    margin-top: 30px;
    text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/project/measures.vue